import React, { useState, useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const directors = [
  {
    id: 1,
    name: 'Anamika Chaudhary',
    role: 'Founder/Executive Producer',
    specialty: 'Brand Strategy & Production',
    icon: 'people-icon',
    bio: 'Strategic visionary leading our brand development and executive production excellence. Expert in transforming creative concepts into compelling brand narratives.'
  },
  {
    id: 2,
    name: 'Tyag Dharmik',
    role: 'Founder/Director',
    specialty: 'Creative Direction & Filmmaking',
    icon: 'people-icon',
    bio: 'Creative force behind our cinematic excellence. Award-winning director specializing in innovative storytelling and visual artistry that defines our production signature.'
  }
];

const DirectorsPage = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hoveredDirector, setHoveredDirector] = useState(null);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <div className="bg-black min-h-screen">
      <Navbar />
      
      <main className="pt-32 pb-24 px-6 lg:px-24">
        <div className="max-w-6xl mx-auto">
          {/* Page Title */}
          <div
            className={`mb-20 transition-all duration-1000 ${
              isLoaded ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'
            }`}
          >
            <h1
              className="text-white text-5xl md:text-7xl lg:text-8xl font-spectral tracking-wide font-spectral"
              style={{ fontFamily: "'Spectral SC', serif" }}
            >
              DIRECTORS
            </h1>
            <p className="text-white/60 text-lg mt-6 max-w-2xl font-spectral">
              Meet our creative visionaries who craft compelling stories.
            </p>
          </div>

          {/* Directors Display - Only Two */}
          <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
            {directors.map((director, index) => (
              <div
                key={director.id}
                className={`flex-1 transition-all duration-1000 ${
                  isLoaded ? 'translate-y-0 opacity-100' : 'translate-y-12 opacity-0'
                }`}
                style={{ transitionDelay: `${300 + index * 200}ms` }}
                onMouseEnter={() => setHoveredDirector(director.id)}
                onMouseLeave={() => setHoveredDirector(null)}
              >
                <div className="group relative">
                  {/* Director Logo Circle */}
                  <div className="relative mb-8">
                    <div className="w-32 h-32 md:w-40 md:h-40 lg:w-48 lg:h-48 mx-auto rounded-full flex items-center justify-center bg-white">
                      {/* People Icon */}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-1/2 w-1/2 text-black"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                        <circle cx="9" cy="7" r="4"></circle>
                        <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                        <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                      </svg>
                    </div>
                    {/* No hover ring effect */}
                  </div>

                  {/* Director Info */}
                  <div className="space-y-4">
                    {/* Name and Role */}
                    <div>
                      <h2
                        className="text-white text-3xl md:text-4xl font-spectral tracking-wide mb-2"
                        style={{ fontFamily: "'Spectral SC', serif" }}
                      >
                        {director.name}
                      </h2>
                      <p className="text-white/60 text-sm tracking-[0.2em] uppercase">
                        {director.role}
                      </p>
                    </div>

                    {/* Specialty */}
                    <div className="pb-4 border-b border-white/20">
                      <p className="text-white/80 text-sm tracking-wide">
                        {director.specialty}
                      </p>
                    </div>

                    {/* Bio */}
                    <div>
                      <p
                        className={`text-white/60 text-sm leading-relaxed transition-all duration-500 ${
                          hoveredDirector === director.id
                            ? 'translate-y-0 opacity-100'
                            : 'translate-y-2 opacity-0'
                        }`}
                      >
                        {director.bio}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default DirectorsPage;
